import { render, staticRenderFns } from "./assetType.vue?vue&type=template&id=472dcec4&scoped=true&"
import script from "./assetType.vue?vue&type=script&lang=js&"
export * from "./assetType.vue?vue&type=script&lang=js&"
import style0 from "./assetType.vue?vue&type=style&index=0&id=472dcec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dcec4",
  null
  
)

export default component.exports